import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {EntityRota} from '~entity/entity-rota/entity-rota.model';
import * as RotaActions from '~entity/entity-rota/entity-rota.actions';
import {tap} from 'rxjs/operators';
import {updatedsIds} from '~entity/entity-update/entity-update.actions';
import {Update} from '@ngrx/entity';

@Injectable()
export class EntityRotaEffects {
  private addRotas$ = createEffect(() => this.actions$.pipe(
    ofType(...[RotaActions.upsertEntityRotas, RotaActions.addEntityRotas]),
    tap(({entities}: { entities: EntityRota[] }) => this.dispatch(entities))
  ), {dispatch: false});

  private addRota$ = createEffect(() => this.actions$.pipe(
    ofType(...[RotaActions.upsertEntityRota, RotaActions.addEntityRota]),
    tap(({entity}: { entity: EntityRota }) => this.dispatch([entity]))
  ), {dispatch: false});

  private updateRotas$ = createEffect(() => this.actions$.pipe(
    ofType(...[RotaActions.updateEntityRotas]),
    tap(({entities}: { entities: Update<EntityRota>[] }) => this.dispatch((entities || []).map(r => r.changes).filter(v => v) as EntityRota[]))
  ), {dispatch: false});

  private updateRota$ = createEffect(() => this.actions$.pipe(
    ofType(...[RotaActions.updateEntityRota]),
    tap(({entity}: { entity: Update<EntityRota> }) => this.dispatch([entity.changes as EntityRota]))
  ), {dispatch: false});

  private dispatch(rotas: EntityRota[]): void {
    const entities = rotas.map(r => ({id: r.id}));
    this.store.dispatch(updatedsIds({entities}) as any);
  }

  constructor(
    private actions$: Actions,
    private store: Store<EntityRota>
  ) {
  }

}
